import { createStore } from 'vuex'
import user from './modules/user'
import app from './modules/app'
import permission from './modules/permission'
import getters from './getters'

export default createStore({
  modules: {
    app,
    user,
    permission
  },
  getters
})
